
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import WhoItsFor from './components/WhoItsFor';
import WhyPaced from './components/WhyPaced';
import CoachBio from './components/CoachBio';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import SocialMedia from './components/SocialMedia';
import FinalCTA from './components/FinalCTA';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Features />
      <WhoItsFor />
      <WhyPaced />
      <CoachBio />
      <Testimonials />
      <Pricing />
      <SocialMedia />
      <FinalCTA />
    </div>
  );
}
